import { useEffect, useRef, useState } from "react";
import {
  Modal,
  Form,
  Container,
  Content,
  Button,
  Schema,
  Loader,
  SelectPicker,
  Input,
  FlexboxGrid,
  DatePicker,
} from "rsuite";
import { updateIn } from "json-immut";
import { StringType, NumberType } from "schema-typed";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { isNotEmpty } from "../../../utils/helpers";
import { useSelector } from "react-redux";
import {
  dateFormatObj,
  messageTypeArr,
  orderStatusObj,
  orderStatusObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import React from "react";
import moment from "moment";

const Textarea = React.forwardRef((props: any, ref: any) => (
  <Input {...props} as="textarea" ref={ref} />
));

const CancelRestoreOrder = ({
  openModal,
  setOpenModal,
  orderObj,
  onCancelRestoreOrder,
}: {
  openModal: boolean;
  setOpenModal: any;
  orderObj: any;
  onCancelRestoreOrder: Function;
}) => {
  const { t } = useTranslation();
  const userActionData = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const formRef = useRef<any>();

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [formData, setFormData] = useState({
    order_status:
      orderObj?.order_status == orderStatusObj.cancelled.value
        ? orderStatusObj.pending.value
        : orderStatusObj.cancelled.value,
    order_cancellation_reason: orderObj?.order_cancellation_reason,
    follow_up_date: isNotEmpty(orderObj?.follow_up_date)
      ? new Date(
          moment(orderObj?.follow_up_date).format(dateFormatObj.moment_y_m_d)
        )
      : null,
    notes: orderObj?.notes,
  });
  const [loader, setLoader] = useState(false);

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  const formModel = Schema.Model({
    order_cancellation_reason: StringType(),
  });

  async function updateOrder(orderId: number, payload: any) {
    try {
      setLoader(true);
      if (onCancelRestoreOrder) onCancelRestoreOrder(orderId, payload);
      setLoader(false);
      setOpenModal("");
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const orderChangeSubmitted = () => {
    let formFields: any = { ...formData };
    let payload = {
      order_status:
        orderObj.order_status == orderStatusObj.cancelled.value
          ? formFields["order_status"]
          : orderStatusObj.cancelled.value,
      order_cancellation_reason: formFields["order_cancellation_reason"],
      follow_up_date: formFields["follow_up_date"],
      notes: formFields["notes"],
    };
    updateOrder(+orderObj.id, payload);
  };

  useEffect(() => {}, []);

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            backdrop
            content={t("LOADING")}
            vertical
          />
        )}
        <Modal.Header>
          <h4>
            {orderObj.order_status == orderStatusObj.cancelled.value
              ? t("RESTORE")
              : t("CANCEL")}{" "}
            {t("ORDER")} {t("FOR")} <b>{orderObj.customer_name}</b>
            {" ("}
            <b> {orderObj.customer_phone}</b>
            {" )"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Content className="edit-cnt mt-2 content pt-0 ">
              <Form
                layout="inline"
                ref={formRef}
                model={formModel}
                formError={formError}
                formDefaultValue={formData}
                onCheck={(e: any) => {
                  setFormError(e);
                }}
                onSubmit={(e: any) => {
                  if (e) {
                    orderChangeSubmitted();
                  }
                }}
                onChange={(data: any) => {
                  setFormData(data);
                }}
              >
                <div className="d-flex cncl-order-fld mr-0">
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item className="col-md-11">
                    <Form.Group controlId="order_cancellation_reason">
                      <Form.ControlLabel>{t("REASON")}</Form.ControlLabel>
                      <Form.Control
                        name="order_cancellation_reason"
                        rows={3}
                        accepter={Textarea}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  {orderObj.order_status == orderStatusObj.cancelled.value && (
                    <FlexboxGrid.Item className="col-md-10">
                      <Form.Group>
                        <Form.ControlLabel>{t("STATUS")}</Form.ControlLabel>
                        <SelectPicker
                          data={orderStatusObjArr.filter(
                            (item) =>
                              item.value != orderStatusObj.cancelled.value
                          )}
                          valueKey="value"
                          labelKey="label"
                          onSelect={(value, item) => {
                            handleFormChanges({ path: "order_status", value });
                          }}
                          onClean={(e: any) => {
                            handleFormChanges({
                              path: "order_status",
                              value: "",
                            });
                          }}
                          name="order_status"
                          value={formData?.order_status}
                          size="sm"
                        />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  )}
                </FlexboxGrid>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item className="col-md-12">
                    <Form.Group controlId="follow_up_date">
                      <Form.ControlLabel>
                        {t("EXPECTED")} {t("NEXT")} {t("ORDER")} {t("DATE")}
                      </Form.ControlLabel>
                      <DatePicker
                        value={formData?.follow_up_date}
                        format={dateFormatObj.calendar_d_m_y}
                        name="follow_up_date"
                        id="follow_up_date"
                        className="mb-0"
                        onChange={(e: any) => {
                          handleDateChange(e, "follow_up_date");
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item className="col-md-12 nxt-ordr-nt">
                    <Form.Group controlId="notes">
                      <Form.ControlLabel>
                        {t("NEXT")} {t("ORDER")} {t("NOTE")}
                      </Form.ControlLabel>
                      <Form.Control
                        name="notes"
                        rows={2}
                        accepter={Textarea}
                        onChange={(e: any) => {
                          handleFormChanges({
                            path: "notes",
                            value: e,
                          });
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                </div> 
                <div className="usr-form-btn mt-0">
                  <Form.Group>
                    <Button
                      appearance="primary"
                      onClick={(e: any) => setIsFormSubmitted(true)}
                      type="submit"
                    >
                      {orderObj.order_status == orderStatusObj.cancelled.value
                        ? t("RESTORE")
                        : t("CANCEL") + " " + t("ORDER")}
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={(e: any) => {
                        setIsFormSubmitted(false);
                        setOpenModal("");
                      }}
                      appearance="primary"
                      color="red"
                      type="reset"
                    >
                      {t("CLOSE")}
                    </Button>
                  </Form.Group>
                </div>
              </Form>
            </Content>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CancelRestoreOrder;
